<template>
  <div>
    <v-dialog
    :value="value" 
    @input="$emit('input')"
    transition="fade-transition" 
    scrollable 
    width="800px" >
      <v-card>
        <v-card-title class="custom-card-title">
          Please complete your Billing Information for the payment process.
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="bg-white" style="margin-top:20px;">
          <table>
            <tr>
              <td>Full Name <small>(as per bank account)</small></td>
              <td>
                <div>
                  <v-text-field
                    class="edit-field"
                    v-model="editData.fullName"
                    dense
                    outlined
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </div>
              </td>
            </tr>
            <tr>
              <td>Country</td>
              <td>
                <div>
                  <v-select
                    v-model="editData.country"
                    label="Country"
                    :items="countries"
                    item-text="name"
                    item-value="name"
                    @change="changeCountry"
                    attach
                    dense
                    hide-details
                    outlined
                  >
                  </v-select>
                </div>
              </td>
            </tr>
            <tr>
              <td>Bank Name</td>
              <td>
                <div>
                  <v-combobox
                    class="edit-field"
                    v-model="editData.bankName"
                    :items="bankNames"
                    item-text="bank"
                    item-value="bank"
                    :search-input.sync="newBankName"
                    attach
                    dense
                    hide-details
                    outlined
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <span class="subheading pr-2" v-if="newBankName">{{ newBankName }}</span>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </div>
              </td>
            </tr>
            <tr>
              <td>Bank Account Number</td>
              <td>
                <div>
                  <v-text-field
                    class="edit-field"
                    v-model="editData.bankAccount"                     
                    v-mask="'#################'"
                    dense
                    outlined
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </div>
              </td>
            </tr>
            <tr>
              <td>Billing Email</td>
              <td>
                <div>
                  <v-text-field
                    class="edit-field"
                    v-model="editData.billingEmail"
                    dense
                    outlined
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </div>
              </td>
            </tr>
            <tr>
              <td>Mailing Address</td>
              <td>
                <div>
                  <v-text-field
                    class="edit-field"
                    v-model="editData.mailingAddress"
                    dense
                    outlined
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </div>
              </td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn text
            color="secondary"
            :disabled="$v.editData.$invalid"
            @click="saveBillingInfo"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>;
import { mapState } from 'vuex';
import influencerAPIs from '../Influencer/influencerAPIs'
import userAPIs from './userAPIs';
import countries from '../../../../static/sources/countries';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
export default {
  name: 'BillingInfoModal',
  props: {
    value: Boolean,
    infData: Object
  },
  mixins: [validationMixin],
  data () {
    return {
      countries: [],
      allBanks: [],
      bankNames: [],
      disableBankSelect: false,
      editData: {
        fullName: '',
        country: '',
        bankName: '',
        bankAccount: '',
        billingEmail: '',
        mailingAddress: ''
      }
    }
  },
  validations: {
    editData: {
      fullName: { required },
      country: { required },
      bankName: { required },
      bankAccount: { required },
      billingEmail: { required },
      mailingAddress: { required }
      // lastName: { required },
      // phone: { required }
      // country: { required },
      // bankName: { required },
      // bankAccount: {
      //   required,
      // }
      // fullName: { required },
      // mailingAddress: { required }
    }
  },
  computed: {
    ...mapState(['user', 'activePlatform']),
    currentUserID: function() {
      return this.user.id;
    }
  },
  watch: {
    infData: function(newUserData) {
      this.editData.fullName = newUserData.fullName
      this.editData.country = newUserData.country
      this.editData.bankName = newUserData.bankName
      this.editData.bankAccount = newUserData.bankAccount
      this.editData.billingEmail = newUserData.billingEmail || ''
      this.editData.mailingAddress = newUserData.mailingAddress || ''
    }
  },
  mounted() {
    // Retrieve countries manually
    this.countries = countries
    this.editData.fullName = this.infData.fullName
    this.editData.country = this.infData.country
    this.editData.bankName = this.infData.bankName
    this.editData.bankAccount = this.infData.bankAccount
    this.editData.billingEmail = this.infData.billingEmail || ''
    this.editData.mailingAddress = this.infData.mailingAddress || ''
  },
  methods: {
    async saveBillingInfo() {
      console.log('dd')
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please fill the required information correctly.'
        });
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        this.loading = true;
        if (result.value) {
          if (typeof this.editData.bankName === 'object') {
            this.editData.swiftCode = this.editData.bankName.swift_code
            this.editData.bankName = this.editData.bankName.bank
          }
          let edittingUserProfile = Object.assign({ id: this.currentUserID }, this.infData, this.editData);
          if (edittingUserProfile.billingEmail) {
            edittingUserProfile.billingEmail = edittingUserProfile.billingEmail.toLowerCase()
          }
          let formData = this.buildFormData(edittingUserProfile)
          // Edit User
          userAPIs
            .editProfile(formData)
            .then(response => {
              // Success Message
              this.loading = false;
              this.$swal({
                title: 'Successfully updated!',
                text: 'Your billing information has been updated successfully. Thank you for working with us!',
                type: 'success'
              });
              this.$emit('updated')
              this.close()
            })
            .catch(error => {
              // Display popup message
              this.loading = false;
              this.$swal({
                title: 'Error!',
                text: 'Please kindly try again or contact us!',
                type: 'error'
              });

              // Request failed.
              console.log('error', error);
            });
        }
      })
    },
    buildFormData(userProfile) {
      // let form = document.getElementById('campaignForm');
      let formData = new FormData();
      // Make sure the images appended at bottom
      // let images = formData.getAll('images')
      formData.append('editProfile', JSON.stringify(userProfile));
      return formData;
    },
    async changeCountry() {
      try {
        this.bankNames = []
        let country = this.countries.find(c => c.name === this.editData.country)
        if (!country) {
          return;
        }
        this.disableBankSelect = true
        await this.getBanks(country.code)
        let matchBank = this.allBanks.find(bank => bank.country_code === country.code)
        if (matchBank && matchBank.list !== undefined) {
          this.bankNames = matchBank.list.filter(bank => bank.branch === null)
        }
        this.disableBankSelect = false
      } catch (err) {
        console.log(err)
        this.bankNames = []
        this.disableBankSelect = false
      }
    },
    async getBanks(code) {
      try {
        this.allBanks = await influencerAPIs.getBanks(code)
      } catch (error) {
        console.log('error', error);
      }
    },
    close() {
      this.$emit('input')
    }
  }
}
</script>

<style scoped>
  .card-box {
    margin: 10px;
  }
  .img-box {
    z-index: 1;
    max-height: 200px;
    max-width: 200px;
  }
  table {
  border-collapse: collapse;
  width: 100%;
  }
  table td .edit-field {
    font-size:13px;
  }
  th, td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
  }
  tr:hover {background-color:#f5f5f5;}
  .caption {
    padding: 8px;
    font-style: italic;
  }
  .deliverables {
    font-size: 15px;
    font-weight: 400;
  }
  .deliverables ul{
    font-weight: 600;
    line-height: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// BillingInfoModal.vue?8f69003e